// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"70":"0cfae007","171":"074ea70f","256":"3b0a1cd8","640":"a3987299"}[chunkId] + ".css";
};